export default __webpack_public_path__ + "static/media/AngolaINEFOP.81c50017.png";